<template>
  <div class="all-api">
    <section class="page-hero">
      <div class="container">
        <h1>{{ source === 'search' ? '搜索结果' : '接口列表' }}</h1>
        <p v-if="source === 'search'">关键词「{{ name }}」，共匹配 {{ pages }} 个接口。</p>
        <p v-else>全部标准 / 可定制化接口，可按分类筛选并查看完整文档与在线试调。</p>
      </div>
    </section>

    <!-- 热门接口 -->
    <section class="band band-alt" v-if="arr3.length">
      <div class="container">
        <div class="band-head">
          <span class="band-num">HOT</span>
          <h2>高频接口</h2>
          <span class="rule"></span>
        </div>
        <div class="grid grid-3">
          <div class="doc-card-sm" v-for="(demo, id) in arr3.slice(0, 6)" :key="'hot' + id">
            <div class="doc-card-top">
              <span class="doc-tag cat">{{ demo.dimName || '接口' }}</span>
            </div>
            <h3>{{ demo.name }}</h3>
            <p>{{ demo.descr }}</p>
            <div class="doc-card-foot">
              <span class="doc-card-meta">接口 ID：{{ demo.showId || demo.id }}</span>
              <a class="doc-card-link" href="javascript:;" @click="goDetail(demo.dimId, demo.id)">查看详情 →</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 分类筛选 + 接口清单 -->
    <section class="band">
      <div class="container">
        <div class="api-tabs">
          <button
            class="api-tab"
            :class="{ active: !shows && !$route.query.source }"
            type="button"
            @click="listChange('', '接口列表', allItem)"
          >
            全部 <span>({{ allItem }})</span>
          </button>
          <button
            class="api-tab"
            v-for="(item, index) in caselist"
            :key="index"
            :class="{ active: shows === item.id }"
            type="button"
            @click="listChange(item.id, item.name, item.num)"
          >
            {{ item.name }} <span>({{ item.num }})</span>
          </button>
        </div>

        <div class="band-head api-list-heading">
          <span class="band-num">LIST</span>
          <h2>{{ source === 'search' ? `搜索结果（${pages}）` : `${name}（${total}）` }}</h2>
          <span class="rule"></span>
        </div>

        <div class="grid grid-3" v-if="arr2.length > 0">
          <div class="doc-card-sm" v-for="item in arr2" :key="item.id">
            <div class="doc-card-top">
              <span class="badge get" v-if="item.reqMethod">{{ item.reqMethod }}</span>
              <span class="badge json" v-if="item.respFormat">{{ item.respFormat }}</span>
              <span class="api-price" v-if="item.price">¥{{ item.price }}</span>
            </div>
            <h3 v-html="gettitle(item.name)"></h3>
            <p>{{ item.descr }}</p>
            <div class="doc-card-foot">
              <span class="doc-card-meta">接口 ID：{{ item.showId || item.id }}</span>
              <a class="doc-card-link" href="javascript:;" @click="goDetail(item.dimId, item.id)">查看详情 →</a>
            </div>
            <button class="btn btn-ghost btn-sm apply-btn" type="button" @click.stop="goApply(item.dimId, item.id)">申请接口</button>
          </div>
        </div>

        <div class="api-list-empty empty-block" v-else>
          <p>暂无搜索结果</p>
        </div>

        <div v-if="pages > 10" class="api-pager">
          <el-pagination
            background
            :current-page="currentPage"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="pages"
          ></el-pagination>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* 接口列表 / 搜索结果页（原 /allApi）
   视觉改用 handoff 设计体系，**接口与参数完全沿用原实现**：
     portal/api/interface        按分类 / 关键词分页取接口
     portal/api/interface/dim    分类清单
     portal/api/interface/refer  高频接口
   导航搜索框仍跳转到本页（/allApi?search=..&source=search）。 */
import { portalApi } from '@/api';

export default {
  name: 'allApi',
  data() {
    return {
      shows: 0,
      name: '',
      total: 0,
      caselist: [],
      arr2: [],
      arr3: [],
      pages: 1,
      currentPage: 1,
      source: 'list',
      allItem: 0
    };
  },
  methods: {
    listChange(id, name, num) {
      this.$store.commit('setSearchData', '');
      this.$route.query.source = '';
      this.shows = id;
      this.name = name;
      this.total = num;
      this.source = 'list';
      this.getRight('', 1);
    },
    goDetail(dimId, index) {
      this.$router.push(`/apiDetail?dimId=${dimId}&id=${index}`);
    },
    goApply() {
      const user = this.$cookies.getJSON('user');
      if (user && user.userId) {
        this.$router.push('/center/case3?from=detail');
      } else {
        this.$store.commit('setShowLogin', 1);
      }
    },
    handleCurrentChange(val) {
      if (this.source === 'search') {
        this.getRight(this.name, val);
      } else {
        this.getRight('', val);
      }
      window.scrollTo(0, 0);
    },
    getRight(name, page) {
      this.currentPage = page;
      const params = {
        dimId: this.shows,
        name: name,
        pageNum: page
      };
      portalApi.getInterfaceList(params)
        .then((res) => {
          if (res.state === 200) {
            // 与原实现一致：状态码非 200 时提示错误
          } else {
            this.$message.error(res.message);
          }
          try {
            const arr = [];
            res.data.item.records.forEach(item => {
              arr.push(...item.intfList);
            });
            this.arr2 = arr;
          } catch (e) {
            console.log(e);
          }
          this.pages = res.data.item.total;
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    gettitle(name) {
      const sea = this.$store.state.searchData;
      if (sea) {
        return name.replace(sea, `<span style="color:#1a56db">${sea}</span>`);
      }
      return name;
    },
    getLeft() {
      portalApi.getDimensionList()
        .then((res) => {
          if (res.state === 200) {
            // 与原实现一致：状态码非 200 时提示错误
          } else {
            this.$message.error(res.message);
          }
          this.caselist = res.data.items;
          this.allItem = res.data.total;
          if (!this.$route.query.source) {
            this.listChange('', '接口列表', res.data.total);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    getTop() {
      portalApi.getRecommendList()
        .then((res) => {
          if (res.state === 200) {
            // 与原实现一致：状态码非 200 时提示错误
          } else {
            this.$message.error(res.message);
          }
          this.arr3 = res.data;
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    searchData() {
      this.shows = '';
      this.name = this.$route.query.search;
      this.source = 'search';
      this.getRight(this.$route.query.search, 1);
    }
  },
  beforeDestroy() {
    this.$store.commit('setSearchData', '');
  },
  mounted() {
    if (this.$route.query.source === 'search') {
      this.$store.commit('setSearchData', this.$route.query.search);
      this.searchData();
    }
    this.getLeft();
    this.getTop();
  },
  watch: {
    '$route.query.search': {
      handler() {
        this.searchData();
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/api/allApi.vue